import React from "react";
import { Button } from "@/components/ui/button";
import { Heart, Building2, HandHeart } from "lucide-react";

export const SupportHero = () => {
  const scrollToSupport = () => {
    const supportTabs = document.getElementById('support-tabs');
    if (supportTabs) {
      supportTabs.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10">
      <div className="absolute inset-0 bg-[url('/img/cayman-aerial.png')] bg-cover bg-center opacity-20" />
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-4">
            <Heart className="h-16 w-16 text-primary animate-pulse" />
            <Building2 className="h-12 w-12 text-secondary" />
            <HandHeart className="h-14 w-14 text-accent" />
          </div>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold mb-8 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
          Support Our Mission
        </h1>
        
        <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-4xl mx-auto leading-relaxed">
          Join us in bringing quality children's entertainment and Cayman Islands culture to families worldwide. 
          Whether you're a corporation looking to partner with us or an individual who wants to make a difference, 
          there's a way for everyone to support our mission.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Button 
            onClick={scrollToSupport}
            size="lg" 
            className="text-lg px-8 py-6 bg-primary hover:bg-primary/90"
          >
            <Building2 className="mr-2 h-5 w-5" />
            Corporate Partnership
          </Button>
          
          <Button 
            onClick={scrollToSupport}
            size="lg" 
            variant="outline"
            className="text-lg px-8 py-6 border-2"
          >
            <Heart className="mr-2 h-5 w-5" />
            Individual Donation
          </Button>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="p-6 bg-white/80 backdrop-blur-sm rounded-xl shadow-lg">
            <div className="text-3xl font-bold text-primary mb-2">200K+</div>
            <div className="text-muted-foreground">Children Reached</div>
          </div>
          
          <div className="p-6 bg-white/80 backdrop-blur-sm rounded-xl shadow-lg">
            <div className="text-3xl font-bold text-secondary mb-2">50+</div>
            <div className="text-muted-foreground">Educational Episodes</div>
          </div>
          
          <div className="p-6 bg-white/80 backdrop-blur-sm rounded-xl shadow-lg">
            <div className="text-3xl font-bold text-accent mb-2">15+</div>
            <div className="text-muted-foreground">Community Partners</div>
          </div>
        </div>
      </div>
    </section>
  );
};